import { render, staticRenderFns } from "./emailNotification.vue?vue&type=template&id=38383402&scoped=true&"
import script from "./emailNotification.vue?vue&type=script&lang=js&"
export * from "./emailNotification.vue?vue&type=script&lang=js&"
import style0 from "./emailNotification.vue?vue&type=style&index=0&lang=css&"
import style1 from "./emailNotification.vue?vue&type=style&index=1&id=38383402&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38383402",
  null
  
)

export default component.exports